import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { XIcon } from "@phosphor-icons/react";
import Container from "../Container";
import IconButton from "components/IconButton";
import useOnEscape from "hooks/useOnEscape";

export default function SearchOverlay({
    visible,
    setVisible,
}) {

    const inputRef = useRef(null);

    useOnEscape(visible, () => setVisible(false));

    // Move focus into the search field when the overlay opens.
    useEffect(() => {
        if (visible) {
            const id = window.setTimeout(() => inputRef.current?.focus(), 300);
            return () => window.clearTimeout(id);
        }
        return undefined;
    }, [visible]);

    const Classes = classNames({
        'fixed z-[var(--z-modal)] bg-black left-0 top-0 bottom-0 w-screen transition-all duration-300 ease-in-out': true,
        'opacity-100 delay-300': visible,
        'opacity-0 pointer-events-none': !visible,
    })

    return (
        <>
            <div
                aria-hidden="true"
                className={`fixed z-[var(--z-modal)] -top-10 -right-10 w-12 h-12 bg-black rounded-full transition-scale transition-opacity-0 duration-500 ease-in-out ${visible ? 'scale-[35] opacity-100' : 'scale-[1] pointer-events-none opacity-100'}`}
                onClick={() => setVisible(false)}
            ></div>

            <div
                className={Classes}
                role="dialog"
                aria-modal="true"
                aria-label="Ricerca"
                aria-hidden={!visible}
            >
                <div className={`w-full px-5 py-6 flex justify-between items-center`}>
                    <div></div>
                    <IconButton tone="dark" label="Chiudi ricerca" onClick={() => setVisible(false)}>
                        <XIcon size={28} className='fill-white' />
                    </IconButton>
                </div>

                <Container>
                    <div className={`relative transition-all delay-300 ${visible ? 'translate-y-0' : 'translate-y-3'}`}>
                        <div className='text-center pb-10'>
                            <p className='text-3xl text-white'>Cosa stai cercando?</p>
                        </div>

                        <div className="w-full relative ">
                            <input
                                ref={inputRef}
                                type="text"
                                aria-label="Cosa stai cercando?"
                                placeholder="Es. cerca le fatture di…"
                                className="relative w-full font-normal bg-grey py-5 px-5 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-white/30 transition-all duration-300 ease-in-out"
                            />
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
